import React, { Component } from 'react';
import { Button, Col, Form, Input, message, Row, Table } from 'antd';
import { queryDeleteWorkOrgHr, queryHrListByWorkOrg, querySaveWorkOrgHr } from '@api/hr/workOrg';
import ModalUsers from './ModalUsers';

const FormItem = Form.Item;

class FormWorkOrg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: {},
      data: [],
      pageNo: 1,
      visible: false,
    };
  }

  componentDidMount() {
    if (this.props.detail.uuid) {
      this.loadData(this.props.detail.uuid, this.state.pageNo);
    }
  }

  handleSaveRelateHr = params => {
    params.uuid = this.state.detail.uuid;
    querySaveWorkOrgHr(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.loadData(this.props.detail.uuid, this.state.pageNo);
        this.handleVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  loadData = (uuid, pageNo) => {
    this.setState({ detail: this.props.detail });
    const params = {};
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 10;
    params.start = current;
    params.uuid = uuid;
    queryHrListByWorkOrg(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({ data: res.data, total: res.totalSize, pageNo });
      } else {
        message.error(res.message);
      }
    });
  };

  handleVisible = flag => {
    this.setState({ visible: !!flag });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { onSubmit } = this.props;
    const { detail } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = values;
        if (detail.uuid) {
          params.uuid = detail.uuid;
        }
        onSubmit(params);
      }
    });
  };

  delete = uuid => {
    queryDeleteWorkOrgHr({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        const ceil = Math.ceil((this.state.total - 1) / 10);
        if (ceil < this.state.pageNo) {
          this.loadData(this.props.detail.uuid, ceil);
        } else {
          this.loadData(this.props.detail.uuid, this.state.pageNo);
        }
        this.handleVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => [
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '操作',
      key: 'done',
      render: (rext, record) => (
        <span>
          <a onClick={() => this.delete(record.uuid)}>删除</a>
        </span>
      ),
    },
  ];

  render() {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { detail, total, data, visible } = this.state;
    const ItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };

    const pagination = {
      showSizeChanger: false,
      pageSize: 10,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.loadData(detail.uuid, current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <div>
        <Form onSubmit={this.submit}>
          <div style={{ marginBottom: 15 }}>
            <Button icon="save" style={{ marginRight: 10 }} htmlType="submit">
              保存
            </Button>
            {detail.uuid ? (
              <Button
                icon="save"
                style={{ marginRight: 10 }}
                onClick={() => this.handleVisible(true)}
              >
                关联人员
              </Button>
            ) : null}
          </div>
          <Row>
            <Col span={12}>
              <FormItem label="业务部门名称" {...ItemLayout}>
                {getFieldDecorator('name', {
                  rules: [{ require: true, message: '请输入业务部门名称!' }],
                  initialValue: detail.name,
                })(<Input placeholder="业务部门名称" />)}
              </FormItem>
            </Col>
          </Row>
          {detail.uuid ? (
            <Row>
              <Table
                style={{ background: '#fff' }}
                columns={this.columns()}
                dataSource={data}
                pagination={pagination}
                rowKey="uuid"
              />
            </Row>
          ) : null}
        </Form>
        {visible ? (
          <ModalUsers
            handleSubmit={this.handleSaveRelateHr}
            handleCancel={() => this.handleVisible(false)}
          />
        ) : null}
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(FormWorkOrg);



// WEBPACK FOOTER //
// ./src/components/hr/workorg/FormWorkorg.js